import { DebitType } from '../../../../types/DebitType';

/**
 * Maps each DebitType to the number of billing periods per year.
 * Used to convert an annualised interval sum back to the correct per-period amount.
 *   Monthly  → 12 periods/year
 *   Weekly   → 52 periods/year
 *   Unit / OneTime / Ongoing → 1 (no annualisation needed)
 */
export const DebitTypeTranslationForCalculation: Record<DebitType, number> = {
  [DebitType.Monthly]: 12,
  [DebitType.Weekly]: 52,
  [DebitType.Unit]: 1,
  [DebitType.OneTime]: 1,
  [DebitType.Ongoing]: 1,
};

/**
 * Reads numberOfUnitsAtUnitPrice as a number of units: hours written as H:mm for a service
 * billed by the hour, otherwise a count that may have decimals (e.g. "1:30" → 1.5, "2.5" → 2.5).
 * The backend reads the field the same way.
 */
export const unitsAtUnitPrice = (value?: string): number => {
  if (!value) return 0;

  const [h = '0', m = '0'] = value.split(':');

  return (Number(h) || 0) + (Number(m) || 0) / 60;
};
